<template>
	<div>
		<header class="top-card" :style="`background:${colorParams.headerCol}`">
			<div class="container-fluid px-0 mw-1200">
				<div class="row px-0 mx-0">
					<div class="col-md-4 px-3 pt-3">
						<div class="reputation-widget mb-2" :style="`background:${colorParams.headerCol}`">
							<div class="header">
								<div class="">
									<img
										:src="
											baseURL + '/assets/img/embed/guestflip-logo-light.png'
										"
									/>
								</div>
							</div>

							<div class="main-body">
								<div class="rating mr-2">
									<span class="hotel-rating b">{{
										starStats.averageRating
											.toFixed(1)
											.toString()
											.replace('.', ',')
											.replace(',0', '')
									}}</span
									><span class="base-rating">/5</span>
								</div>
								<div class="stars">
									<div class="rating-caption text-center pt-1">
										<div v-if="starStats.averageRating >= 4">Awesome</div>
										<div v-else-if="starStats.averageRating >= 3">Good</div>
										<div v-else-if="starStats.averageRating >= 2">
											Satisfactory
										</div>
										<div v-else></div>
									</div>
									<div class="rating-stars text-center">
										<img
											:src="baseURL + '/assets/img/embed/star-half.png'"
											v-if="starStats.averageRating < 1"
										/>
										<img
											:src="baseURL + '/assets/img/embed/star.png'"
											v-if="starStats.averageRating >= 1"
										/>
										<img
											:src="baseURL + '/assets/img/embed/star.png'"
											v-if="starStats.averageRating >= 2"
										/>
										<img
											:src="baseURL + '/assets/img/embed/star-half.png'"
											v-if="
												(starStats.averageRating < 2) &
												(starStats.averageRating > 1)
											"
										/>
										<img
											:src="baseURL + '/assets/img/embed/star.png'"
											v-if="starStats.averageRating >= 3"
										/>
										<img
											:src="baseURL + '/assets/img/embed/star-half.png'"
											v-if="
												(starStats.averageRating < 3) &
												(starStats.averageRating > 2)
											"
										/>
										<img
											:src="baseURL + '/assets/img/embed/star.png'"
											v-if="starStats.averageRating >= 4"
										/>
										<img
											:src="baseURL + '/assets/img/embed/star-half.png'"
											v-if="
												(starStats.averageRating < 4) &
												(starStats.averageRating > 3)
											"
										/>
										<img
											:src="baseURL + '/assets/img/embed/star.png'"
											v-if="starStats.averageRating >= 5"
										/>
										<img
											:src="baseURL + '/assets/img/embed/star-half.png'"
											v-if="
												(starStats.averageRating < 5) &
												(starStats.averageRating > 4)
											"
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div
						class="col-md-8 d-flex flex-column align-items-center justify-content-center"
					>
						<div class="p-2">
							<h5 class="mb-0">
								Summary of
								{{
									starStats.totalReviews
										.toFixed(2)
										.replace(/\d(?=(\d{3})+\.)/g, '$&,')
										.replace('.00', '')
								}}
								Reviews
							</h5>
						</div>
						<div class="p-2">
							<h6 class="mb-0 rating-caption">
								These are the best topics for the latest
								{{ filteredStatsCount }} Reviews
							</h6>
						</div>
					</div>
				</div>
			</div>
		</header>

		<div class="container-fluid mw-1200">
			<!-- Layout -->
			<div class="row py-4 justify-content-center">
				<div class="col-md-8">
					<div class="row">
						<!-- Summary -->
						<div class="col-md-12" v-if="sentimentStats && starStats">
							<div
								class="summary text-center d-flex justify-content-center align-items-center flex-md-row flex-column"
                                :style="`background:${colorParams.backgroundCol}`"
							>
								<p class="summary-score mb-0">
									Rated
									<span class="b">{{ currentRating }}/5</span> based on reviews
									from
								</p>
								<div class="dropdown show ml-2">
									<a
										href="#"
										class="dots"
										role="button"
										id="dropdownMenuLink"
										data-toggle="dropdown"
										aria-haspopup="true"
										aria-expanded="false"
									>
										<span class="b tt"
											>{{ compositionLabel }} <i class="fa fa-angle-down"></i
										></span>
									</a>

									<div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
										<a
											class="dropdown-item"
											href="#"
											@click.prevent="chooseComposition('all')"
										>
											All Travelers
										</a>
										<a
											class="dropdown-item"
											v-for="composition in sentimentStats.compositions"
											:key="composition.type"
											href="#"
											@click.prevent="chooseComposition(composition.type)"
										>
											{{ names[composition.type] }}
										</a>
									</div>
								</div>
								<div>
									<a href="#" @click.prevent="expandDescription"> </a>
								</div>
							</div>
						</div>
					</div>
					<!-- Reviews -->
					<div v-if="sentimentStats">
						<div
							class="category row"
							v-for="stat in filteredStats"
							:key="stat.subcategory"
						>
							<div class="category-stats col-md-3">
								<h2>
									{{ formatSubcategory(stat.subcategory) }}
								</h2>
								<div class="rating">
									<div class="guestflip-ui bar-chart bar-chart-monochrome">
										<div
											class="value value-pos"
											:style="stat.values.width"
										></div>
									</div>
									<div class="score">
										{{ stat.score.toFixed(1) }}<span class="text-pos"></span>/5
									</div>
								</div>
								<div class="review-count">
									{{ stat.values.total + ' reviews' }}
								</div>
							</div>
							<div class="col-md-9">
								<p>
									{{ stat.description }}
								</p>
								<p class="readable-text" v-if="stat.subDescription">
									{{ stat.subDescription }}
								</p>
							</div>
						</div>
					</div>
					<!-- Sidebar -->
					<div class="col-md-4">
						<div class="row">
							<!-- Awards -->
							<div class="col-md-12">
								<div class="row">
									<!-- Award image placeholder -->
									<div class="col-md-4"></div>
									<!-- Award text placeholder  -->
									<div class="col-md-8"></div>
								</div>
							</div>
						</div>
						<!-- Good to know -->
						<div class="row">
							<div class="col-md-12">
								<div class="row">
									<!-- Good to know text -->
									<div class="col-md-12"></div>
								</div>
								<div class="row">
									<!-- Check or cross mark -->
									<div class="col-md-2"></div>
									<!-- Great view , spacious rooms etc -->
									<div class="col-md-10"></div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: ['data', 'widgetId', 'teamId'],
	data() {
		return {
			baseURL: window.location.origin,
			sentimentStats: null,
			statsLoading: false,
			activeComposition: 'all',
			params: {
				fromDate: `1970-01-01`,
				toDate: moment().format('YYYY-MM-DD'),
				targets: null,
				scores: null,
			},
			starStats: {
				totalReviews: 0,
				averageRating: 0,
			},
			names: {
				all: 'All travelers',
				business: 'Business Travelers',
				couples: 'Couples',
				families: 'Families',
				solo: 'Solo Travelers',
				friends: 'Friends',
				group: 'Groups',
			},
		};
	},
	watch: {
		params: {
			immediate: true,
			deep: true,
			handler: function (newVal, oldVal) {
				this.getAllStats();
			},
		},
	},
	computed: {
		colorParams() {
            //Extract backgroundCol and headerCol from get params
            const urlParams = new URLSearchParams(window.location.search);
            const backgroundCol = urlParams.get('bodyCol');
            const headerCol = urlParams.get('headerCol');

            if (backgroundCol) {
                    document.body.style.backgroundColor = `#${backgroundCol}`;
            }

            return {
                backgroundCol: backgroundCol ? `#${backgroundCol}` : '#f9f9f9',
                headerCol: headerCol ? `#${headerCol}` : '#f9f9f9',
            };
		},
		currentRating() {
			if (this.activeComposition == 'all') {
				return this.starStats.averageRating
					.toFixed(1)
					.toString()
					.replace('.', ',')
					.replace(',0', '');
			}
			const that = this;
			const comp = this.sentimentStats.compositions.filter((elem) => {
				return elem.type == that.activeComposition;
			})[0];
			return comp.averageRating.toFixed(1).toString().replace('.', ',').replace(',0', '');
		},
		compositionLabel() {
			return this.names[this.activeComposition];
		},
		filteredStats() {
			if (!this.sentimentStats) {
				return {};
			}

			const vm = this;
			var topics = Object.values(this.sentimentStats.topics);
			if (this.activeComposition !== 'all') {
				const comp = this.sentimentStats.compositions.filter((elem) => {
					return elem.type == vm.activeComposition;
				})[0];
				topics = comp.topics;
			}

			return topics
				.filter((topic) => {
					return (
						parseInt(topic.positive) + parseInt(topic.negative) > 0 &&
						parseFloat(topic.score) > 2.5
					);
				})
				.map((elem) => {
					elem.values = vm.getValues(elem);
					return elem;
				});
		},
		filteredStatsCount() {
			if (!this.filteredStats.length > 0) {
				return [];
			}

			return this.filteredStats
				.map((elem) => {
					return elem.values.total;
				})
				.reduce((partialSum, val) => partialSum + val, 0);
		},
	},
	methods: {
		chooseComposition(composition) {
			this.activeComposition = composition;
		},
		deGeneralize(val) {
			let parts = val.split('_general');
			if (parts.length == 2) {
				return parts[0];
			}
			return val.split('_').join(' ');
		},
		formatSubcategory(val) {
			val = this.deGeneralize(val);
			val = val.charAt(0).toUpperCase() + val.slice(1);
			return val;
		},
		getScore(elem) {
			var total = parseInt(elem.positive) + parseInt(elem.negative);
			var difference = parseInt(elem.positive) - parseInt(elem.negative);
			var score = ((difference / total) * 5).toFixed(1);
		},
		getValues(elem) {
			var total = parseInt(elem.positive) + parseInt(elem.negative);
			var difference = parseInt(elem.positive) - parseInt(elem.negative);
			var score = ((difference / total) * 5).toFixed(1);
			var width = 'width:' + elem.score * 20 + '%';
			var termDescription = elem.term_description;

			return {
				total: total,
				score: score,
				termDescription: termDescription,
				width: width,
			};
		},
		getTargetsAndScores() {
			var targetsAndScores = {
				targets: [],
				scores: [],
			};

			const vm = this;

			this.sentimentStats.subcategories.map(function (elem) {
				targetsAndScores['targets'].push(vm.deGeneralize(elem));
				targetsAndScores['scores'].push(vm.getValues(elem)['normalizedScore']);
			});

			return targetsAndScores;
		},
		normalizeNumber(valueIn, baseMin, baseMax, limitMin, limitMax) {
			return ((limitMax - limitMin) * (valueIn - baseMin)) / (baseMax - baseMin) + limitMin;
		},
		getAllStats() {
			this.statsLoading = true;
			axios
				.get(
					`/embed/${this.teamId}/stats?fromDate=${this.params.fromDate}&toDate=${this.params.toDate}`,
				)
				.then((response) => {
					this.sentimentStats = response.data;
				});
			axios.get(`/api/widget/${this.teamId}/`).then((response) => {
				this.statsLoading = false;
				const stats = response.data.stats;
				this.starStats = {
					totalReviews: stats.totalReviews ? Number.parseInt(stats.totalReviews) : 0,
					averageRating: stats.averageRating ? Number.parseFloat(stats.averageRating) : 0,
				};
			});
		},
	},
};
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css?family=Open+Sans');

.dropdown .dropdown-menu {
	background: #f9f9f9;
}

.mw-1200 {
	max-width: 1200px;
}

h1,
h2,
h3,
h4,
h5 {
	font-family: 'Open Sans', sans-serif;
}

.b {
	font-weight: 500;
	color: black;
}
a:hover .b {
	color: #00aef1;
}
.tt {
	font-size: 1.4em;
}

.summary {
	background: #f9f9f9;
	border-radius: 4px;
	border: 1px solid #ebebeb;
	padding: 15px;
	width: 100%;
	color: #333;
	float: left;
	margin-bottom: 20px;
}

.summary p.summary-score {
	font-weight: 300;
	font-size: 1.4em;
}

.summary .summary-sentence {
	font-weight: 400;
	font-size: 16px;
	line-height: 1.4em;
}

.top-card {
	background: #f9f9f9;
}
.reputation-widget {
	background: #f9f9f9;
	font-family: 'Open Sans', sans-serif;
	/* max-width: 270px; */
	display: flex;
	flex-direction: column;
	height: auto;
	font-weight: bold;
}
.reputation-widget.dark {
	background: #212b3c;
	border-color: #212b3c;
}
.reputation-widget > .header {
	flex: 100%;
	display: flex;
	flex-wrap: wrap;
	width: 100%;
	max-height: 50px;
	margin-bottom: 5px;
}
.reputation-widget > .main-body {
	flex: 100%;
	display: flex;
	align-items: stretch;
}
.reputation-widget > .header > .top-image,
.reputation-widget > .header > .info-tooltip {
	flex: 50%;
}
.reputation-widget > .header > .info-tooltip {
	text-align: right;
	cursor: pointer;
}
.reputation-widget > .main-body > .stars {
	text-align: left;
}
.reputation-widget > .main-body > .stars .rating-caption {
	color: #9c9da9;
	font-size: 12px;
	padding-bottom: 4px;
}

.reputation-widget.dark > .main-body .base-rating {
	color: #484b60;
}
.reputation-widget > .main-body > .stars img {
	padding: 0 3px;
}

.reputation-widget > .main-body .hotel-rating {
	font-size: 40px;
	color: #00afef;
}
.reputation-widget.dark > .footer {
	color: white;
}

.text-pos {
	color: #00afef;
}

.guestflip-ui.bar-chart {
	min-width: 100px;
	height: 15px;
	background: #e5e5e5;
	display: block;
}

.guestflip-ui.bar-chart .value {
	background: #3498db;
	min-width: 3px;
	height: 100%;
	float: left;
}

.guestflip-ui.bar-chart .value:hover {
	background: #109fff;
}

.guestflip-ui.bar-chart .value:active {
	background: #2386c8;
}

.guestflip-ui.bar-chart .value.value-pos {
	border-color: #00acf0;
	background: #00acf0;
}

.guestflip-ui.bar-chart .value.value-pos {
	color: #fff;
}

.guestflip-ui.bar-chart .value.value-pos:hover {
	background: #91d7f7;
}

.guestflip-ui.bar-chart .value.value-pos:active {
	background: #017db9;
}

.guestflip-ui.bar-chart.bar-chart-monochrome .value.value-pos {
	border-color: #00acf0;
	background: #00acf0;
}

.guestflip-ui.bar-chart.bar-chart-monochrome .value.value-pos:hover {
	background: #91d7f7;
}

.guestflip-ui.bar-chart.bar-chart-monochrome .value.value-pos:active {
	background: #017db9;
}

* {
	-moz-box-sizing: border-box;
	-webkit-box-sizing: border-box;
	box-sizing: border-box;
}

:focus {
	outline: 0;
}

.category {
	margin-top: 20px;
}

.category:after {
	clear: both;
	display: table;
	content: '';
}

.category:first-child {
	margin-top: 0;
}

.category:after:after {
	clear: both;
	display: table;
	content: '';
}

.category .category-stats h2 {
	word-break: break-word;
	-moz-hyphens: auto;
	-ms-hyphens: auto;
	-webkit-hyphens: auto;
	hyphens: auto;
	font-size: 1em;
	font-weight: 400;
	padding-right: 10px;
}

.category .category-stats h2:after {
	clear: both;
	display: table;
	content: '';
}

@media (max-width: 480px) {
	.category .category-stats h2 {
		font-size: 1.2em;
		margin-bottom: 5px;
		font-weight: 300;
	}
}

.category .category-stats .rating {
	margin: 5px 0;
}

.category .category-stats .rating:after {
	clear: both;
	display: table;
	content: '';
}

@media (max-width: 480px) {
	.category .category-stats .rating {
		float: left;
		margin-bottom: 0;
	}
	.category .category-stats .rating:after {
		clear: both;
		display: table;
		content: '';
	}
}

.category .category-stats .rating .bar-chart {
	height: 13px;
	min-width: 100px;
	float: left;
	margin: 3px 10px 0 0;
}

@media (max-width: 768px) {
	.category .category-stats .rating .bar-chart {
		min-width: 80px;
	}
}

@media (max-width: 480px) {
	.category .category-stats .rating .bar-chart {
		min-width: 100px;
		margin: 2px 5px 0 0;
	}
}

.category .category-stats .rating .score {
	float: left;
	font-size: 0.9em;
	padding: 2px 0;
	color: #999;
}

.category .category-stats .rating .score:after {
	clear: both;
	display: table;
	content: '';
}

@media (max-width: 768px) {
	.category .category-stats .rating .score {
		font-size: 0.85em;
	}
}

.category .category-stats .rating .score span {
	font-weight: 500;
	margin-right: 2px;
}

.category .category-stats .review-count {
	color: #999;
	font-size: 0.85em;
}

@media (max-width: 480px) {
	.category .category-stats .review-count {
		float: left;
		margin-top: 5px;
		padding: 2px 0;
	}
	.category .category-stats .review-count:after {
		clear: both;
		display: table;
		content: '';
	}
	.category .category-stats .review-count:before {
		content: '\2022';
		padding: 0 7px;
	}
}

.category .category-details {
	padding-left: 170px;
}

@media (max-width: 768px) {
	.category .category-details {
		padding-left: 150px;
	}
}

@media (max-width: 480px) {
	.category .category-details {
		padding-left: 0;
	}
}

.category .category-details p {
	display: block;
	line-height: 1.4em;
	font-size: 1em;
	padding-left: 2px;
	margin-bottom: 2px;
}

.category .category-details p span {
	display: block;
}

.category .category-details p span:first-child {
	font-weight: 500;
}

@media (max-width: 768px) {
	.category .category-details p {
		padding-left: 0;
		margin-bottom: 4px;
	}
}

@media (max-width: 480px) {
	.category .category-details p span {
		display: inline;
	}
}

.guestflip-ui * {
	-webkit-box-sizing: border-box;
	-moz-box-sizing: border-box;
	box-sizing: border-box;
}

.guestflip-ui {
	font-size: 14px;
}
</style>
